import { useLocation } from 'react-router-dom';

function LoggedOff({ headingText, bodyText }: { headingText: string; bodyText?: string }) {
  const from = useLocation().state?.from || '/';

  function handleLogin() {
    const safeFrom = typeof from === 'string' && from.startsWith('/') ? from : '/';
    window.location.replace(safeFrom);
  }

  return (
    <div className="text-center">
      <h1 className={!bodyText ? 'mb-4' : ''}>{headingText}</h1>
      {bodyText && <div className="mb-3">{bodyText}</div>}
      <button className="btn btn-primary" onClick={handleLogin}>
        Logga in
      </button>
    </div>
  );
}

export default LoggedOff;
